import { Autocomplete, InputAdornment, Box, Stack, TextField, Typography, createFilterOptions } from "@mui/material";
import BuildingIcon from "@entrilia/shared/icons/BuildingIcon.tsx";
import type { BalanceSheetEntityOption } from "../utils/balanceSheetEntityFilter.ts";

interface Props {
  options: BalanceSheetEntityOption[];
  value: BalanceSheetEntityOption | null;
  onChange: (value: BalanceSheetEntityOption | null) => void;
}

const filterOptions = createFilterOptions<BalanceSheetEntityOption>({
  stringify: (option) => `${option.entityNo} ${option.entityName}`.trim(),
});

const BalanceSheetEntityFilter = ({ options, value, onChange }: Props) => {
  return (
    <Autocomplete
      size="small"
      value={value}
      options={options}
      onChange={(_, option) => onChange(option)}
      filterOptions={filterOptions}
      isOptionEqualToValue={(option, selected) => option.entityNo === selected.entityNo}
      getOptionLabel={(option) => option.entityNo}
      noOptionsText="No entities"
      sx={{ minWidth: 240 }}
      renderOption={({ key: _key, ...props }, option) => {
        return (
          <Box component="li" key={option.id} {...props}>
            <Stack direction="column">
              <Typography sx={{ whiteSpace: "nowrap" }}>{option.entityNo}</Typography>
              <Typography color="textSecondary" sx={{ whiteSpace: "nowrap" }}>
                {option.entityName}
              </Typography>
            </Stack>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,

              placeholder: "Select Entity",
              startAdornment: (
                <>
                  <InputAdornment position="start" sx={{ pl: 1 }}>
                    <BuildingIcon fontSize="small" color="action" />
                  </InputAdornment>
                  {params.slotProps.input.startAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default BalanceSheetEntityFilter;
